import React from 'react';

function Icon({ name, size = 24, stroke = 1.8 }) {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: stroke,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  switch (name) {
    case 'camera':
      return (
        <svg {...props}>
          <path d='M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z' />
          <circle cx='12' cy='13' r='4' />
        </svg>
      );
    case 'cpu':
      return (
        <svg {...props}>
          <rect x='4' y='4' width='16' height='16' rx='2' />
          <rect x='9' y='9' width='6' height='6' />
          <line x1='9' y1='1' x2='9' y2='4' />
          <line x1='15' y1='1' x2='15' y2='4' />
          <line x1='9' y1='20' x2='9' y2='23' />
          <line x1='15' y1='20' x2='15' y2='23' />
          <line x1='20' y1='9' x2='23' y2='9' />
          <line x1='20' y1='14' x2='23' y2='14' />
          <line x1='1' y1='9' x2='4' y2='9' />
          <line x1='1' y1='14' x2='4' y2='14' />
        </svg>
      );
    case 'alert':
      return (
        <svg {...props}>
          <path d='M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' />
          <line x1='12' y1='9' x2='12' y2='13' />
          <line x1='12' y1='17' x2='12.01' y2='17' />
        </svg>
      );
    case 'chart':
      return (
        <svg {...props}>
          <line x1='18' y1='20' x2='18' y2='10' />
          <line x1='12' y1='20' x2='12' y2='4' />
          <line x1='6' y1='20' x2='6' y2='14' />
        </svg>
      );
    case 'shield':
      return (
        <svg {...props}>
          <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
        </svg>
      );
    case 'shield-check':
      return (
        <svg {...props}>
          <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
          <path d='M9 12l2 2 4-4' />
        </svg>
      );
    case 'shield-down':
      return (
        <svg {...props}>
          <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
          <polyline points='8 12 12 16 16 12' />
        </svg>
      );
    case 'clock':
      return (
        <svg {...props}>
          <circle cx='12' cy='12' r='10' />
          <polyline points='12 6 12 12 16 14' />
        </svg>
      );
    case 'check':
      return (
        <svg {...props}>
          <polyline points='20 6 9 17 4 12' />
        </svg>
      );
    case 'check-circle':
      return (
        <svg {...props}>
          <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
          <polyline points='22 4 12 14.01 9 11.01' />
        </svg>
      );
    case 'arrow-right':
      return (
        <svg {...props}>
          <line x1='5' y1='12' x2='19' y2='12' />
          <polyline points='12 5 19 12 12 19' />
        </svg>
      );
    case 'back':
      return (
        <svg {...props}>
          <line x1='19' y1='12' x2='5' y2='12' />
          <polyline points='12 19 5 12 12 5' />
        </svg>
      );
    case 'user':
      return (
        <svg {...props}>
          <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' />
          <circle cx='12' cy='7' r='4' />
        </svg>
      );
    case 'factory':
      return (
        <svg {...props}>
          <path d='M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z' />
          <path d='M17 18h1' />
          <path d='M12 18h1' />
          <path d='M7 18h1' />
        </svg>
      );
    case 'pin':
      return (
        <svg {...props}>
          <path d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' />
          <circle cx='12' cy='10' r='3' />
        </svg>
      );
    case 'headphones':
      return (
        <svg {...props}>
          <path d='M3 18v-6a9 9 0 0 1 18 0v6' />
          <path d='M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z' />
        </svg>
      );
    default:
      return null;
  }
}

export default Icon;
